<template>
  <div class="b-settings__block p-6 mt-6">
    <h2 class="mb-4">{{$t('CONTENT.settingsPage.contract_settings')}}</h2>
    <div v-if="error" class="mb-2">
      <server-error :error="error" />
    </div>
    <form v-if="isLoaded" class="b-form p-0" @submit.prevent="onSubmit">
        <div class="b-settings__block-box row row-no-flex">
          <div class="col-3">
            <div class="b-form__container">
              <label>{{$t('CONTENT.settingsPage.contract_settings_years')}}:</label>
            </div>
          </div>
          <div class="col-2" data-cy="contract-setting-yearsToAddToPerpetuity">
            <numeric class="b-numeric" controls :min="0" :max="100" :disabled="isReadOnlyMode" v-model="currentYearsToAddToPerpetuity" @keypress="changeNumericValue($event)"></numeric>
          </div>
          <div class="col-5 mt-2">
            <div class="b-settings__block-note">{{$t('CONTENT.settingsPage.contract_settings_years_note')}}</div>
          </div>
        </div>
        <div class="b-settings__block-box row row-no-flex mt-7">
          <div class="col-2">
            <div class="b-form__container">
              <label>{{$t('CONTENT.settingsPage.contract_settings_currency_code')}}:</label>

              <cool-select :list="allCurrencyCode"
                           option-value="code"
                           option-text="name"
                           :isDisabled="isReadOnlyMode"
                           :placeholder="$t('CONTENT.choose')"
                           v-model="currentCurrencyCode"></cool-select>
            </div>
          </div>
          <div class="col-4 mt-2">
            <div class="b-settings__block-note">{{$t('CONTENT.settingsPage.contract_settings_currency_code_note')}}</div>
          </div>
        </div>
      <div class="b-settings__block-box row row-no-flex mt-7">
        <div class="col-8">
          <div class="b-form__container">
            <label>{{$t('CONTENT.settingsPage.amortization_type')}}:</label>
            <toggle-switch
              :is-read-only-mode="isReadOnlyMode"
              :items="availableAmortizationTypes"
              :picked="picked"
              itemKey="type"
              itemName="name"
              :withHint=true
              @click="clickOnAmortizationType"
            />
          </div>
        </div>
        <div class="col-4 mt-2">
          <div class="b-settings__block-note">{{$t('CONTENT.settingsPage.contract_settings_amortization_note')}}</div>
        </div>
      </div>
        <button
          v-if="!isReadOnlyMode"
          class="b-btn b-btn_type_primary mt-4"
          type="submit"
          data-cy="next-step"
          :disabled="isDisabledSaveBtn"
        >{{$t('CONTENT.save')}}</button>
      </form>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import changeNumericValue from "../../mixins/changeNumericValue";

	export default {
    props: {
      isReadOnlyMode: {
        type: Boolean,
      },
    },
		data() {
			return {
				error: null,
				currencyCode: null,
				yearsToAddToPerpetuity: null,
        amortizationType: null,
				isDisabledSaveBtn: true,
        availableAmortizationTypes: [
          {
            name: this.$t('CONTENT.settingsPage.daily_amortization'),
            type: 'daily_amortization',
            hint: this.$t('CONTENT.hints.daily_amortization'),
          },
          {
            name: this.$t('CONTENT.settingsPage.monthly_amortization'),
            type: 'monthly_amortization',
            hint: this.$t('CONTENT.hints.monthly_amortization'),
          },
          {
            name: this.$t('CONTENT.settingsPage.monthlywithoutfirst_amortization'),
            type: 'monthlywithoutfirst_amortization',
            hint: this.$t('CONTENT.hints.monthlywithoutfirst_amortization'),
          }
        ]
			}
		},
    mixins: [changeNumericValue],
		computed: {
			...mapGetters(['getCurrencyCode']),
			...mapGetters(['getContractSettings']),
      allCurrencyCode() {
				return this.getCurrencyCode;
      },
      picked() {
			  return this.getContractSettings.amortizationType;
      },
      currentCurrencyCode: {
				get() {
				  if (this.currencyCode !== null) {
            return this.currencyCode.toLowerCase();
          } else {
            this.currencyCode = this.getContractSettings.currencyCode;
            return this.currencyCode.toLowerCase();
          }
        },
        set(newVal) {
          this.currencyCode = newVal.toUpperCase();
          this.isDisabledSaveBtn = false;
        }
      },
      currentYearsToAddToPerpetuity: {
				get() {
					this.yearsToAddToPerpetuity = this.getContractSettings.yearsToAddToPerpetuity;
					return this.getContractSettings.yearsToAddToPerpetuity;
        },
        set(newVal) {
          this.yearsToAddToPerpetuity = newVal;
        }
      }
    },
    watch: {
			yearsToAddToPerpetuity(value, oldValue) {
				if(oldValue !== value && oldValue !== null) {
					this.isDisabledSaveBtn = false;
				}
      }
    },
    methods: {
      clickOnAmortizationType(type) {
        this.amortizationType = type;
        this.isDisabledSaveBtn = false;
      },
			async onSubmit() {
				try {
					this.error = null;
					this.$loadingManager.addLoadingStep();
					await this.$store.dispatch('setContractSettings', {currencyCode: this.currencyCode, yearsToAddToPerpetuity: this.yearsToAddToPerpetuity, amortizationType: this.amortizationType});
					this.$loadingManager.loadingStepLoaded();
				} catch (e) {
					this.$loadingManager.hideLoadScreen();
					this.error = e;
				}
			}
    }
	}
</script>
